module.exports = __webpack_public_path__ + "assets/icn-custom-project.5f20074e.svg";